import { render, staticRenderFns } from "./Editing.vue?vue&type=template&id=84ac5d96&scoped=true"
import script from "./Editing.vue?vue&type=script&lang=js"
export * from "./Editing.vue?vue&type=script&lang=js"
import style0 from "./Editing.vue?vue&type=style&index=0&id=84ac5d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ac5d96",
  null
  
)

export default component.exports